import { Machine } from "xstate"

export const SettingsFacilitiesMachine = Machine({
  id: "SettingsFacilities",
  initial: "tableView",
  states: {
    tableView: {
      on: {
        ADD_CATEGORY: "addCategory",
        UPDATE_CATEGORY: "updateCategory"
      }
    },
    addCategory: {
      on: {
        BACK: "tableView"
      }
    },
    updateCategory: {
      on: {
        BACK: "tableView"
      }
    },
    addFacility: {
      on: {
        BACK: "tableView"
      }
    },
    updateFacility: {
      on: {
        BACK: "tableView"
      }
    },
    showFacilities: {
      on: {
        BACK: "tableView"
      }
    }
  },
  on: {
    TABLE_VIEW: "tableView",
    ADD_CATEGORY: "addCategory",
    UPDATE_CATEGORY: "updateCategory",
    ADD_FACILITY: "addFacility",
    UPDATE_FACILITY: "updateFacility",
    SHOW_FACILITIES: "showFacilities"
  }
})
